import { mergeStyles } from "@fluentui/react";
export const useReviewFormStyles = () => {
    const ReviewFormStyle = {
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        "& .section": {
            width: "100%",
            minWidth: 0,
            paddingBottom: "10px",
            "& .reviewForm-row": {
                display: "flex",
                flexWrap: "wrap",
                minWidth: 0,
                "& .rowLabel": {
                    minWidth: "250px",
                    maxWidth: "420px",
                    width: "30%",
                    color: "#6a6866",
                    overflowWrap: "anywhere",
                    "@media (max-width: 400px)": {
                        width: "100%",
                        minWidth: 0,
                        maxWidth: "100%",
                    },
                },
                "& .valueList ul": {
                    paddingLeft: 0,
                    margin: 0,
                },
                "& .rowValue": {
                    width: "500px",
                    minWidth: 0,
                    maxWidth: "100%",
                    overflowWrap: "anywhere",
                },
            },
        },
    };
    return mergeStyles(ReviewFormStyle);
};
